var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "movies-grid-item relative" },
    [
      _vm.$viewer.isActive
        ? _c(
            "button",
            {
              staticClass: "block w-full h-auto group",
              attrs: { title: _vm.linkTitle },
              on: {
                click: function($event) {
                  return _vm.$viewer.setMovie(_vm.movie)
                }
              }
            },
            [
              _c("MoviePoster", {
                attrs: { url: _vm.movie.posterUrl, title: _vm.movie.title }
              }),
              _c("div", {
                staticClass:
                  "absolute inset-0 bg-black opacity-0 group-hover:opacity-25"
              })
            ],
            1
          )
        : [
            _c(
              "router-link",
              {
                staticClass: "block group",
                attrs: {
                  to: { name: "movie", params: { uuid: _vm.movie.uuid } },
                  title: _vm.linkTitle,
                  "aria-label": _vm.linkTitle
                }
              },
              [
                _c("MoviePoster", {
                  attrs: { url: _vm.movie.posterUrl, title: _vm.movie.title }
                }),
                _c("div", {
                  staticClass:
                    "absolute inset-0 bg-black opacity-0 group-hover:opacity-25"
                })
              ],
              1
            ),
            !_vm.$viewer.isActive
              ? _c(
                  _vm.movie.watched ? "div" : "button",
                  _vm._b(
                    {
                      tag: "component",
                      staticClass:
                        "badge absolute top-0 right-0 -mt-1 w-10 h-10 flex items-center justify-center",
                      staticStyle: { "margin-right": "-.7rem" },
                      attrs: {
                        title: _vm.movie.watched ? null : "Mark watched",
                        "aria-label": _vm.movie.watched
                          ? null
                          : "Mark " + _vm.movie.title + " as watched"
                      },
                      on: {
                        click: function($event) {
                          _vm.movie.pending && _vm.markWatched($event)
                        }
                      }
                    },
                    "component",
                    _vm.movie.watched
                      ? { class: "watched" }
                      : { type: "button" },
                    false
                  ),
                  [
                    _c("BaseIcon", {
                      staticClass: "background absolute inset-0 w-10 h-10",
                      attrs: { name: "bookmark" }
                    }),
                    _vm.movie.pending
                      ? _c("BaseIcon", {
                          staticClass:
                            "icon-pending text-blue-600 w-4 h-4 z-10",
                          attrs: { name: "time" }
                        })
                      : _vm._e(),
                    _c("BaseIcon", {
                      staticClass: "icon-watched text-green-600 w-4 h-4 z-10",
                      attrs: { name: "checkmark" }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }